<template>
  <div class="locationselector__overlay" :class="{'-open': open}">
    <div class="overlay__overlay">
      <div class="overlay__headline">
       <span class="heading beta -color-black">Passende Adresse auswählen</span>
      </div>
      <div class="overlay__content">
        <template v-for="(location) in locations.getLocations" :key="location.id">
          <label
              :for="'location_'+location.id"
              class="content__suggestion"
              :class="{'-filled': locations.selectedLocation === location.number}">
            <input
                type="radio"
                :id="'location_'+location.id"
                name="location"
                :value="location.number"
                @change="saveLocation(location)"
                v-model="locations.selectedLocation">
            <span class="heading gamma">
              {{ location.street + ' '
              + location.houseNumber + location.houseNumberAddition + ', '
              + location.postcode + ' '
              + location.city }}
            </span>
          </label>
        </template>
        <div class="no-results" v-if="locations.getLocations.length < 1">
          <p>Für Ihre Eingabe wurden keine Ergebnisse gefunden</p>
        </div>
      </div>
      <div class="cta-wrapper">
        <button class="-btn-beta -mobile-link" @click="goBack()">
          <span>Zurück zur Eingabe</span>
        </button>
        <button v-if="locations.getLocations.length >= 1" class="-btn-beta"
                @click="handleSubmit()"
                type="button"><span>Anschrift bestätigen</span>

        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useLocationStore } from '@/stores/location';
import { useViewStore } from '@/stores/view';

export default {
  name: 'LocationSelector',
  props: {
    open: Boolean,
  },
  methods: {
    handleSubmit() {
      if (this.locations.selectedLocation) {
        this.$emit('updateView', 'ContactDataEntry');
      }
    },
    saveLocation(loc) {
      this.locations.selectedLocationObject = loc;
    },
    goBack() {
      this.$emit('closeOverlay');
    },
  },
  setup() {
    const locations = useLocationStore();
    const view = useViewStore();
    return {
      locations,
      view,
    };
  },
};
</script>
